import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { IonContent } from '@ionic/react';

import { screen } from '$fcomponents/hoc';

import { IonPageWrapper } from './styles';
import { Div, SPACE } from '$gstyles';
import { phone as formatPhone } from '$gbusiness/helpers/mask';
import UserModel from '$gbusiness/models/user';
import { Form, Formik } from 'formik';
import { FormSection } from '$gcomponents/reusables';
import { Button, Text } from '$gcomponents/primitives';
import { input } from '$gbusiness/helpers';

import { PROFILE_FORM } from './profileForm';
import { cuserActions } from '$gbusiness/redux/currentUser';
import CardModel from '$gbusiness/models/card';
import Header from '$components/header';
import { userActions } from '$gbusiness/redux/user';

interface ProfileScreenProps {
  user: UserModel;
  cards: Array<CardModel>;
  editProfile: Function;
  deleteCard: Function;
  saveUser: Function;
}

const ProfileScreen: React.FC<ProfileScreenProps> = ({ user, editProfile }) => {
  const formRef = useRef<any>();
  const { userId, firstName, lastName, email, other, settings } = user;

  const onSubmit = (values) => {
    const { firstName, lastName, email, newPassword: password } = values;
    editProfile({
      userId,
      first_name: firstName,
      last_name: lastName,
      email,
      ...(password && { password }),
      // settings,
    });
  };
  const inititalValues = {
    userId,
    firstName,
    lastName,
    email,
    mobile: formatPhone((other?.mobile || '').toString()),
    settings: {
      ...settings,
      emailNotification: settings?.emailNotification || 0,
    },
  };

  const validateForm = (values) => input.validateError(PROFILE_FORM(formRef.current.values), values);

  return (
    <IonPageWrapper>
      <Header title="SCREEN.PROFILE.TITLE" />
      <IonContent>
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          initialValues={inititalValues}
          validate={validateForm}
          onSubmit={(values) => {
            onSubmit(values);
          }}>
          {(formik) => (
            <Div padding={SPACE.LARGE} maxWidth="800px">
              <Form>
                <FormSection FORM={PROFILE_FORM(formik.values)} formik={formik} />
                <Button
                  className="filled primary submit"
                  onClick={formik.handleSubmit}
                  disabled={!(formik.isValid && formik.dirty)}>
                  <Text k="BUTTON.SUBMIT" />
                </Button>
              </Form>
            </Div>
          )}
        </Formik>
      </IonContent>
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  user: state.currentUser,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  editProfile: cuserActions.editProfile,
  saveUser: userActions.saveUser,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(ProfileScreen));
